import { Tabs } from "antd"
import ErrorView from "comps/ErrorView"
import EvaluationList from "comps/EvaluationList"
import Layout from "comps/Layout"
import ProfileAuthDetail from "comps/ProfileAuthDetail"
import ProfileAuthDetailH5 from "comps/ProfileAuthDetailH5"
import ProfileBusinessDetail from "comps/ProfileBusinessDetail"
import ProfileBusinessDetailH5 from "comps/ProfileBusinessDetailH5"
import ProfileMask from "comps/ProfileMask"
import ProfileMaskH5 from "comps/ProfileMaskH5"
import Rate from "comps/Rate"
// import { SimpleNavbar } from "comps/SimpleNavbar"
import useRateAndSellCount from "hooks/useRateAndSellCount"
import Phone from "icons/shop/phone.svg"
import Verify from "icons/shop/verify.svg"
import { MediaQueryContext, SiteContext } from "libs/contexts"
import { ProfilePageData } from "libs/profile-repo"
import { useRouter } from "next/router"
import { useContext, useEffect, useState } from "react"
import { cls } from "reactutils"

const { TabPane } = Tabs

export default function Profile(props: ProfilePageData) {
  const router = useRouter()
  const inIframe: boolean = !!router.query.inIframe
  const site = useContext(SiteContext)
  const { isMobile } = useContext(MediaQueryContext)
  if (isMobile && !props.shopInfo?.sysNo) {
    return <ErrorView statusCode={404} />
  }

  return (
    <Layout
      className={cls(inIframe && "in-iframe-profile-layout")}
      header={null}
      footer={null}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description={`${
        site.basic?.tenantName || ""
      }通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
    >
      {isMobile ? (
        <ProfileContentH5 {...props} />
      ) : (
        <ProfileContentPC {...props} />
      )}

      <style jsx>{`
        :global(body .in-iframe-profile-layout.layout) {
          min-width: 100%;
        }
        :global(body .in-iframe-profile-layout .content-body) {
          background-color: #fff;
        }
      `}</style>
    </Layout>
  )
}

export function ProfileContentPC(props: ProfilePageData) {
  const router = useRouter()
  const inIframe: boolean = !!router.query.inIframe

  useEffect(() => {
    handleChangeHeight()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleChangeHeight() {
    if (inIframe) {
      window.parent.postMessage("changeHeight")
    }
  }

  return (
    <div className={cls(!inIframe && "container-wrap")}>
      <div className="content-wrap">
        <Tabs
          defaultActiveKey="1"
          tabBarStyle={{ paddingLeft: "20px" }}
          onTabClick={handleChangeHeight}
        >
          <TabPane tab="认证信息" key="1">
            {props.hasAudit && props.hasLogin ? (
              <ProfileAuthDetail {...props} />
            ) : (
              <ProfileMask {...props} />
            )}
          </TabPane>
          <TabPane tab="商务信息" key="2">
            {props.hasAudit && props.hasLogin ? (
              <ProfileBusinessDetail {...props} />
            ) : (
              <ProfileMask {...props} />
            )}
          </TabPane>
        </Tabs>
      </div>
      <style jsx>{`
        .container-wrap {
          width: 1200px;
          margin: 0 auto;
        }
        .content-wrap {
          width: 100%;
          border: 1px solid #f1f1f1;
          background-color: #ffff;
        }
      `}</style>
    </div>
  )
}

function ShopInfoH5(props: ProfilePageData) {
  const { canView } = useRateAndSellCount()

  return (
    <div className="info-wrap">
      <h2 className="title">
        {props.shopInfo.name}
        <span className="icon-wrap">
          <Verify />
        </span>
      </h2>
      {canView && props.shopInfo.score !== null && (
        <div className="row-wrap rate">
          <span className="row-label">店铺评分</span>
          <span className="row-value">
            <Rate
              value={+props.shopInfo.score}
              size={14}
              scoreSize={16}
              scoreGutter={8}
            />
          </span>
        </div>
      )}
      <div className="row-wrap">
        <span className="row-label">主营</span>
        <span className="row-value">{props.shopInfo.mainBusiness}</span>
      </div>
      <div className="row-wrap">
        <span className="row-label">店铺客服</span>
        <a className="row-value" href={`tel:${props.shopInfo.serviceHotline}`}>
          {props.shopInfo.serviceHotline}
          <span className="phone-icon">
            <Phone />
          </span>
        </a>
      </div>
      <div className="row-wrap">
        <span className="row-label">服务时间</span>
        <span className="row-value">{props.shopInfo.serviceHours}</span>
      </div>
      <style jsx>{`
        .info-wrap {
          line-height: 1;
          background: #ffffff;
          border-radius: 3px;
          padding: 14px 15px;
        }
        .title {
          font-size: 17px;
          color: #333333;
          font-weight: bold;
          display: flex;
          align-items: flex-start;
        }
        .row-wrap {
          display: flex;
          margin-top: 8px;
          line-height: 24px;
        }
        .row-wrap.rate {
          align-items: center;
        }
        .row-label {
          flex: 0 0 66px;
          font-size: 14px;
          color: #999999;
        }
        .row-value {
          font-size: 14px;
          color: #333333;
        }
        .phone-icon {
          margin-left: 5px;
        }
        .icon-wrap {
          margin-left: 6px;
        }
      `}</style>
    </div>
  )
}

function ProfileContentH5(props: ProfilePageData) {
  const { canView } = useRateAndSellCount()
  const [activeTab, setActiveTab] = useState(1)
  const styleLeft = {
    1: "20px",
    2: "115px",
    3: "210px",
  }

  return (
    <>
      {/* <SimpleNavbar title="店铺档案"></SimpleNavbar> */}
      <div className="page-wrap">
        <ShopInfoH5 {...props} />
        <div className="tab-wrap">
          <div className="active-line" style={{ left: styleLeft[activeTab] }} />
          <div
            onClick={() => {
              setActiveTab(1)
            }}
            className={cls("tab-item", activeTab === 1 && "active")}
          >
            认证信息
          </div>
          <div
            onClick={() => {
              setActiveTab(2)
            }}
            className={cls("tab-item", activeTab === 2 && "active")}
          >
            商务信息
          </div>
          <div
            onClick={() => {
              setActiveTab(3)
            }}
            className={cls("tab-item", activeTab === 3 && "active")}
          >
            评价信息
          </div>
        </div>
        {activeTab === 1 &&
          (props.hasAudit && props.hasLogin ? (
            <ProfileAuthDetailH5 {...props} />
          ) : (
            <ProfileMaskH5 {...props} />
          ))}

        {activeTab === 2 &&
          (props.hasAudit && props.hasLogin ? (
            <ProfileBusinessDetailH5 {...props} />
          ) : (
            <ProfileMaskH5 {...props} />
          ))}

        {activeTab === 3 &&
          (canView ? (
            <EvaluationList
              supplierSysNo={props.shopInfo.supplierSysNo}
              shopScore={props.shopInfo.score}
              listWrapStyle={{
                minHeight: `calc(100vh - 415px)`,
              }}
            />
          ) : (
            <ProfileMaskH5 {...props} />
          ))}
      </div>
      <style jsx>{`
        .page-wrap {
          padding: 10px;
        }
        .page-wrap :global(.shop-score-head) {
          margin-bottom: 1px;
        }
        .tab-wrap {
          padding: 14px 6px;
          display: flex;
          align-items: center;
          position: relative;
        }
        .tab-item {
          font-size: 15px;
          color: #666666;
          margin-right: 35px;
          line-height: 27px;
        }
        .tab-item.active {
          color: var(--primaryColor);
          font-weight: bold;
        }

        .active-line {
          width: 30px;
          height: 2px;
          background-color: var(--primaryColor);
          position: absolute;
          top: 40px;
          transition: all 0.3s;
        }
      `}</style>
    </>
  )
}
